import * as React from "react";

function SvgTrashcan(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.25 8.594a.781.781 0 01.781.781v9.375a.781.781 0 11-1.562 0V9.375a.781.781 0 01.781-.781zm3.906 0a.781.781 0 01.781.781v9.375a.781.781 0 11-1.562 0V9.375a.781.781 0 01.781-.781zm4.688.781a.781.781 0 00-1.563 0v9.375a.781.781 0 001.563 0V9.375z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.313 4.688A1.563 1.563 0 0118.75 6.25h-.781v14.063a3.125 3.125 0 01-3.125 3.125H5.469a3.125 3.125 0 01-3.125-3.125V6.25h-.781A1.562 1.562 0 010 4.687V3.125a1.562 1.562 0 011.563-1.563H7.03A1.562 1.562 0 018.594 0h3.125a1.562 1.562 0 011.562 1.563h5.469a1.563 1.563 0 011.563 1.562v1.563zM4.09 6.25l-.185.092v13.97a1.563 1.563 0 001.563 1.563h9.375a1.562 1.562 0 001.562-1.563V6.342l-.184-.092H4.09zM1.562 4.687V3.125H18.75v1.563H1.562z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgTrashcan;
